import { typeEmpty } from '../type/typeEmpty'
/**
 * @desc 验证是否已填
 * @param {boolean} required
 * @param {String} validateValue
 * @param {*} callback
 * @param {String} field
 * @param {String} [action]
 * @param {Number} [min]
 * @param {Number} [max]
 */
export const vRequire = (required: boolean, validateValue: string, callback: any, field: string, action: string = '填写', min?: number, max?: number): void => {
  if (!required && !validateValue) {
    callback()
  } else {
    if (typeEmpty(validateValue)) {
      action = action || '填写'
      callback(new Error(`${field}必须${action}`))
    } else {
      if (min && max && (validateValue.length < ~~Math.abs(min) || validateValue.length > ~~Math.abs(max))) {
        const howMany = min === max ? String(max) : min + '-' + max
        callback(new Error(`${field}的长度为${howMany}个字符`))
      } else {
        callback()
      }
    }
  }
}
